/**
 * A small RFC 4180 CSV reader for the attachment preview (#335): quoted
 * fields may hold commas, newlines and doubled quotes; CRLF and a leading BOM
 * are accepted; blank lines are skipped. It never throws - an unclosed quote
 * simply runs to the end of the text.
 */
export function parseCsv(text: string): string[][] {
  const src = text.charCodeAt(0) === 0xfeff ? text.slice(1) : text;
  const rows: string[][] = [];
  let row: string[] = [];
  let field = '';
  let quoted = false;
  let i = 0;

  const endRow = () => {
    row.push(field);
    field = '';
    if (row.length > 1 || row[0] !== '') rows.push(row);
    row = [];
  };

  while (i < src.length) {
    const c = src[i];
    if (quoted) {
      if (c === '"') {
        if (src[i + 1] === '"') { field += '"'; i += 2; continue; }
        quoted = false;
      } else {
        field += c;
      }
      i++;
      continue;
    }
    if (c === '"' && field === '') quoted = true;
    else if (c === ',') { row.push(field); field = ''; }
    else if (c === '\n') endRow();
    else if (c === '\r') { if (src[i + 1] !== '\n') endRow(); }
    else field += c;
    i++;
  }
  if (field !== '' || row.length > 0) endRow();
  return rows;
}
